// Checks if a url is a ppc clickout
const isPpcClickOutUrl = url => /\/ppc\//i.test(url)
export default isPpcClickOutUrl
